import httpRequest from '@/utils/request';

const roleUrl = '/Role';
const urlByRoleId = (roleId: string) => {
  return `/Role/${roleId}`;
};

const roleUpdateUsersUrl = (roleId: string) => {
  return `/Role/${roleId}/users`;
};
const roleUpdatePermissionsUrl = (roleId: string) => {
  return `/Role/${roleId}/permissionids`;
};
export const getRoles = (params: IRole.IRequest.IGetRoles = {}): Promise<IRole.IResponse.IData> => {
  return httpRequest.get(roleUrl, {params});
};
export const updateRole = (params: IRole.IRequest.ICreateOrUpdateRole): Promise<IResponseData.IBaseData> => {
  const url = urlByRoleId(params.roleId);
  return httpRequest.post(url, params.data);
};
export const roleAddUsers = (params: IRole.IRequest.IUpdateUsers): Promise<IResponseData.IBaseData> => {
  const url = roleUpdateUsersUrl(params.roleId);
  return httpRequest.post(url, params.userIds);
};
export const roleDelUsers = (params: IRole.IRequest.IUpdateUsers): Promise<IResponseData.IBaseData> => {
  const url = roleUpdateUsersUrl(params.roleId);
  return httpRequest.delete(url, {
    data: params.userIds,
  });
};
export const roleAddPermissions = (params: IRole.IRequest.IUpdatePermissions): Promise<IResponseData.IBaseData> => {
  const url = roleUpdatePermissionsUrl(params.roleId);
  return httpRequest.post(url, params.permissionIds);
};
export const roleDelPermissions = (params: IRole.IRequest.IUpdatePermissions): Promise<IResponseData.IBaseData> => {
  const url = roleUpdatePermissionsUrl(params.roleId);
  return httpRequest.delete(url, {
    data: params.permissionIds,
  });
};
export const delRole = (roleId: string): Promise<IResponseData.IBaseData> => {
  const url = urlByRoleId(roleId);
  return httpRequest.delete(url);
};
